import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePatientFacing } from "./hooks/usePatientFacing";

const PATIENT_FACING_URL = {
  mayo1: "/patient/mayo/landing1",
  mayo2: "/patient/mayo/landing2_angiogram",
  mayo3: "/patient/mayo/landing2_tavr",
  mayo4: "/patient/mayo/landing3",

  gi: "/patient/gi/landing",
  gi2: "/patient/gi2/landing",
}

export default function PatientFacing() {
  const navigate = useNavigate();
  const { eventId } = useParams();
  
  const { event, error } = usePatientFacing(eventId);

  useEffect(() => {
    if (!event?.facingType) return;

    const sending = event.facingType === 'gi' ? '1' : '2';

    // For GI flows, check progress and navigate directly to the correct page
    if (event.facingType === 'gi' || event.facingType === 'gi2') {
      const cpData = event?.Case?.CasesProgresses;
      const cpArray = Array.isArray(cpData) ? cpData : (cpData ? [cpData] : []);
      const progress = cpArray.find(cp => cp?.facingType === event.facingType);
      const hasAvatar = !!progress?.avatarSelection;
      const hasQuestionnaire = !!progress?.answeredQuestionnaire;
      const basePath = event.facingType === 'gi' ? '/patient/gi' : '/patient/gi2';

      if (hasQuestionnaire) {
        const videoPath = event.facingType === 'gi' ? `${basePath}/video` : `${basePath}/video1`;
        navigate(videoPath, { replace: true });
        return;
      }
      if (hasAvatar) {
        navigate(`${basePath}/Questionnaire/diabetesMedicines`, { replace: true });
        return;
      }
    }

    navigate(`${PATIENT_FACING_URL[event.facingType]}/${eventId}?sending=${sending}`, { replace: true });
  }, [event]);

  // Handle expired link error
  if (error?.type === 'expired') {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        textAlign: 'center'
      }}>
        <div style={{
          background: '#f8f9fa',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '500px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '20px'
          }}>⏰</div>
          <h1 style={{
            color: '#dc3545',
            marginBottom: '16px',
            fontSize: '24px'
          }}>Link Expired</h1>
          <p style={{
            color: '#6c757d',
            fontSize: '16px',
            lineHeight: '1.5'
          }}>
            {error.message}
          </p>
          <p style={{
            color: '#6c757d',
            fontSize: '14px',
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: '1px solid #dee2e6'
          }}>
            If you have questions about your procedure, please contact your healthcare provider.
          </p>
        </div>
      </div>
    );
  }

  // Handle other errors
  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        textAlign: 'center'
      }}>
        <div style={{
          background: '#f8f9fa',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '500px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</div>
          <h1 style={{ color: '#dc3545', marginBottom: '16px' }}>Error</h1>
          <p style={{ color: '#6c757d' }}>{error.message}</p>
        </div>
      </div>
    );
  }

  return null;
}
